// extracted by mini-css-extract-plugin
export default {"percentLineWrap":"DemandPercentLine_percentLineWrap__eAn1x","buyPercentLine":"DemandPercentLine_buyPercentLine__PH9GW","sellPercentLine":"DemandPercentLine_sellPercentLine__Ng2gW"};